var map = {
	"./invisible-asia-logo.jpg": "efa5",
	"./invisible-asia-logo.svg": "dd9d",
	"./invisible-asia/1-indonesia.jpg": "687e",
	"./invisible-asia/2-china.jpg": "ccb3",
	"./invisible-asia/3-singapore.jpg": "5459",
	"./invisible-asia/4-thailand.jpg": "8798",
	"./invisible-asia/5-india.jpg": "449c",
	"./invisible-asia/6-hongkong.jpg": "3cf4",
	"./invisible-asia/7-japan.jpg": "53fd",
	"./invisible-asia/8-philippines.jpg": "a2ff",
	"./invisible-asia/9-southkorea.jpg": "d915",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/placeholder-image.png": "83b1",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";